<template>
  <div class="form-group">
    <div class="grey mb5">{{ label ?? name }}</div>
    <textarea :rows="rows" class="form-control" :name="name" :placeholder="placeholder" v-validate="rules"
      v-model="inputValue" :disabled="disabled"></textarea>
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldTextArea',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      inputValue: this.value
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
